(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "axios", "../utils/rcdsEnvir", "../utils/helpers"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("axios"), require("../utils/rcdsEnvir"), require("../utils/helpers"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.axios, global.rcdsEnvir, global.helpers);
    global.appRequest = mod.exports;
  }
})(this, function (exports, _axios, _rcdsEnvir, _helpers) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _axios2 = _interopRequireDefault(_axios);

  var _helpers2 = _interopRequireDefault(_helpers);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  //@TODO: add timeouts
  var appRequest = {
    getRandomChild: function getRandomChild(take) {
      // console.log("params: ", take);
      var urlRoot = (0, _rcdsEnvir.getRcdsEnvironment)();
      var url = urlRoot.url + "/api/Sponsorship/children/random/" + take + "?subscription-key=" + urlRoot.token;
      //let progress = 0;
      // const currentTime = () => {
      //   const time = new Date();
      //   return time.getTime();
      // };
      // const start = currentTime();

      // Make RCDS Request
      return (0, _axios2.default)({
        url: url,
        headers: {
          "Ocp-Apim-Subscription-Key": urlRoot.token
        }
      }).then(function (resp) {
        if (resp.data.success != true) {
          return Promise.reject(resp);
        }
        return resp.data;
      }).catch(function (resp) {
        return resp;
      });
    },
    getSearchChildren: function getSearchChildren(params) {
      var urlRoot = (0, _rcdsEnvir.getRcdsEnvironment)();
      var url = urlRoot.url + "/api/Sponsorship/children/search/web?subscription-key=" + urlRoot.token;
      // let progress = 0;
      // const currentTime = () => {
      //   const time = new Date();
      //   return time.getTime();
      // };
      // const start = currentTime();

      // Make RCDS Request
      return (0, _axios2.default)({
        url: url,
        method: "post",
        data: params,
        headers: {
          "Ocp-Apim-Subscription-Key": urlRoot.token
        }
      }).then(function (resp) {
        if (resp.data.success != true) {
          return Promise.reject(resp);
        }
        // console.log(" response: ", resp.data.message);
        return resp.data;
        // progress = currentTime() - start;
        // return onProgress(progress);
      }).catch(function (resp) {
        // console.log("got the catch", resp.message);
        return resp.message;
      });
    },
    getChildById: function getChildById(id) {
      var urlRoot = (0, _rcdsEnvir.getRcdsEnvironment)();
      var url = urlRoot.url + "/api/Sponsorship/children/" + id + "/web?subscription-key=" + urlRoot.token;
      // Make RCDS Request
      return (0, _axios2.default)({
        url: url,
        method: "get",
        headers: {
          "Ocp-Apim-Subscription-Key": urlRoot.token
        }
      }).then(function (resp) {
        if (resp.data.success != true) {
          // console.log("error response: ", resp);
          return Promise.reject(resp);
        }
        // console.log(" response: ", resp.data.message);
        return resp.data;
      }).catch(function (resp) {
        // console.log("got the catch", resp.message);
        return resp.message;
      });
    },
    getChildStory: function getChildStory(id) {
      var urlRoot = (0, _rcdsEnvir.getRcdsEnvironment)();
      var url = urlRoot.url + "/api/Sponsorship/children/" + id + "/story?subscription-key=" + urlRoot.token;
      // Make RCDS Request
      return (0, _axios2.default)({
        url: url,
        method: "get",
        headers: {
          "Ocp-Apim-Subscription-Key": urlRoot.token
        }
      }).then(function (resp) {
        if (resp.data.success != true) {
          // console.log("error response: ", resp);
          return Promise.reject(resp);
        }
        // console.log(" response: ", resp.data.message);
        return resp.data;
      }).catch(function (resp) {
        // console.log("got the catch", resp.message);
        return resp.message;
      });
    },
    getChildDescriptors: function getChildDescriptors() {
      var urlRoot = (0, _rcdsEnvir.getRcdsEnvironment)();
      var url = urlRoot.sponsorshipAPIurl + "/descriptors";
      return (0, _axios2.default)({
        url: url,
        method: "get"
      }).then(function (resp) {
        if (resp.data.success != true) {
          // console.log("error response: ", resp);
          return Promise.reject(resp);
        }
        // console.log(" response: ", resp.data.message);
        return resp.data;
      }).catch(function (resp) {
        // console.log("got the catch", resp.message);
        return resp.message;
      });
    }
  };

  exports.default = appRequest;
});